import * as types from './mutation_types'

export default {
  [types.SET_LOADING] (state, value) {
    state.loading = value
  },
  [types.SET_SAVING] (state, value) {
    state.saving = value
  },
  [types.SET_GENERATING] (state, value) {
    state.generating = value
  },
  [types.SET_PENDING] (state, value) {
    state.pending = value
  },
  [types.SET_TYPE_MODULE] (state, value) {
    state.typeModule = value
  },
  [types.SET_MODE_INVITE] (state, value) {
    state.modeInvite = value
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/actionState/mutations.js